export enum RepaymentMethods {
  ANNUITY = 'ANNUITY',
  EQUAL_INSTALMENTS = 'EQUAL_INSTALMENTS'
}
